import { render, staticRenderFns } from "./StudentGraduation.vue?vue&type=template&id=039b54c8&scoped=true"
import script from "./StudentGraduation.vue?vue&type=script&lang=js"
export * from "./StudentGraduation.vue?vue&type=script&lang=js"
import style0 from "./StudentGraduation.vue?vue&type=style&index=0&id=039b54c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b54c8",
  null
  
)

export default component.exports